import { useEffect, useState } from 'react';

export const MODAL_TRANSITION_DURATION = 240;

const useModalTransition = (isOpen) => {
  const [shouldRender, setShouldRender] = useState(isOpen);

  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
      return undefined;
    }

    const timeoutId = window.setTimeout(
      () => setShouldRender(false),
      MODAL_TRANSITION_DURATION
    );

    return () => window.clearTimeout(timeoutId);
  }, [isOpen]);

  return shouldRender;
};

export default useModalTransition;
